module.exports = __webpack_public_path__ + "img/hangawi_2022.2eba381b.jpg";